// Deterministic 32-bit PRNG. Solo game — no fairness claim to make, so the
// drand-seeded RNG that backgammon/domino use is overkill. mulberry32 is five
// lines, dependency-free, and pairs with the 8-hex seed-share URL format.

export type Rng = () => number;

const U32_MAX = 0x100000000;

/**
 * Returns a PRNG seeded by `seed >>> 0`. Each call yields a number in [0, 1).
 * Stable across runs and platforms; never use this where unpredictability
 * matters (it doesn't — see module header).
 */
export function mulberry32(seed: number): Rng {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / U32_MAX;
  };
}

/** Uniform integer in [0, n). */
export function randInt(rng: Rng, n: number): number {
  return Math.floor(rng() * n);
}

/** In-place Fisher–Yates shuffle driven by `rng`. Returns the same array. */
export function shuffleInPlace<T>(rng: Rng, arr: T[]): T[] {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = randInt(rng, i + 1);
    const ai = arr[i] as T;
    const aj = arr[j] as T;
    arr[i] = aj;
    arr[j] = ai;
  }
  return arr;
}
